import styled from '@emotion/styled';

export const StyledSearchRoot = styled.div`
  position: relative;
  margin: 0.6em 0;
`